<template>
  <section class="closefriend-hero settings-page">
    <loading-modal :is-loading="isLoading"></loading-modal>
    <b :class="showSlideBar ? 'screen-overlay show' : 'screen-overlay'"></b>
    <influencer-menu @menuClicked="slideBar()" :show-slide-bar="showSlideBar"></influencer-menu>
    <header-menu @slideMenu="slideBar()" :is-loading="isLoading"></header-menu>

    <div class="container-fluid mt-3 pb-5">
      <div class="row justify-content-center">
        <div class="col-12 px-2 px-md-4" style="max-width: 1200px;">
          <!-- Header -->
          <div class="mb-4 mt-2 px-1">
            <h5 class="text-white font-weight-700 mb-0 font-size-20">Account Settings</h5>
            <span class="text-muted font-size-12">Update your profile & preferences</span>
          </div>
            <global-message></global-message>

            <!-- SECTION 1: Profile Images -->
            <div class="settings-section mb-4">
              <h6 class="settings-section-title">Profile</h6>
              <div class="d-flex align-items-center justify-content-center flex-wrap py-3" style="gap: 16px;">
                <div class="img-wrapper text-center" style="height: fit-content;">
                  <div style="position: relative; display: inline-block;">
                    <div class="img-wrapper-main rounded-circle" @click="$refs.wall.show('dp', imgURL, imgType, true)">
                      <img class="img-fluid rounded-circle" v-if="!isAvatarMissing" :src="profileImgURL"
                        @error="imageLoadError">
                      <img v-else src="@/assets/images/default_user.png" class="img-fluid rounded-circle">
                      <input type="file" ref="file" name="image_document" class="d-none" id="file_upload"
                        accept="image/*" @change="handleFileUpload()">
                    </div>
                    <span style="position: absolute; bottom: 0; right: 0;" class="edit-icon zoom-8"
                      @click="$refs.wall.show('dp', imgURL, imgType, true)">
                      <img class="img-fluid invert-color" src="@/assets/images/stella/edit.png">
                    </span>
                  </div>
                  <div class="mt-2 font-weight-bold" style="color: rgba(255,255,255,0.5); font-size: 11px; text-transform: uppercase; letter-spacing: 1px;">Avatar</div>
                </div>

                <div class="img-wrapper text-center mx-2">
                  <div class="img-wrapper-main rounded-coners"
                    @click="$refs.wall.show(1, wall1ImgURL, wall1ImgType)">
                    <img class="img-fluid" v-if="!wall1ImgURL"
                      src="@/assets/images/stella/img-upload-placeholder.png">
                    <img class="img-fluid" v-else :src="wall1ImgURL + '?ver=' + wall1ImgVer">
                  </div>
                  <div class="mt-2 font-weight-bold" style="color: rgba(255,255,255,0.5); font-size: 11px; text-transform: uppercase; letter-spacing: 1px;">Wallpaper</div>
                </div>

                <div class="img-wrapper text-center mx-2">
                  <div class="img-wrapper-main rounded-coners"
                    @click="$refs.wall.show(2, wall2ImgURL, wall2ImgType)">
                    <img class="img-fluid" v-if="!wall2ImgURL"
                      src="@/assets/images/stella/img-upload-placeholder.png">
                    <img class="img-fluid" v-else :src="wall2ImgURL + '?ver=' + wall2ImgVer">
                  </div>
                  <div class="mt-2 font-weight-bold" style="color: rgba(255,255,255,0.5); font-size: 11px; text-transform: uppercase; letter-spacing: 1px;">Wallpaper</div>
                </div>
              </div>
            </div>

            <!-- SECTION 2: Account Info -->
            <div class="settings-section mb-4">
              <h6 class="settings-section-title">Account Info</h6>
              <div class="row px-3 py-3">
                <div class="col-12 mb-3">
                  <label class="settings-label">Name <span class="danger">*</span></label>
                  <input type="text" class="form-control settings-input" placeholder="Example: Adam"
                    v-model="user.name">
                  <span class="error invalid-feedback" v-if="isRequired('name')">This is required field</span>
                </div>

                <div class="col-12 mb-3">
                  <label class="settings-label">Bio</label>
                  <input type="text" class="form-control settings-input" placeholder="Bio"
                    v-model="user.bio">
                </div>

                <div class="col-12 mb-3">
                  <label class="settings-label">Email <span class="danger">*</span></label>
                  <input type="text" class="form-control settings-input"
                    placeholder="Example: myemail@com" v-model="user.email" readonly>
                  <span class="error invalid-feedback" v-if="isRequired('email')">This is required field</span>
                  <span class="error invalid-feedback" v-if="isValidEmail()">Not a valid email address</span>
                </div>

                <div class="col-12 col-md-6 mb-3">
                  <label class="settings-label">Password</label>
                  <input type="password" class="form-control settings-input"
                    placeholder="Update password" autocomplete="false" v-model.trim="pwd">
                  <span v-if="isSubmit && !$v.pwd.required" class="error invalid-feedback">This is required field</span>
                </div>

                <div class="col-12 col-md-6 mb-3">
                  <label class="settings-label">Repeat Password</label>
                  <input type="password" class="form-control settings-input"
                    placeholder="Re-enter new password" v-model.trim="repeatPassword">
                  <span v-if="isSubmit && !$v.repeatPassword.required"
                    class="error invalid-feedback">This is required field</span>
                  <span v-else-if="isSubmit && !$v.repeatPassword.sameAs"
                    class="error invalid-feedback">Passwords must match</span>
                </div>
              </div>
            </div>

            <!-- SECTION 3: Pricing & Subscriptions -->
            <div class="settings-section mb-4">
              <h6 class="settings-section-title">Pricing &amp; Subscriptions</h6>
              <div class="row px-3 py-3">
                <div class="col-12 col-md-6 mb-3">
                  <label class="settings-label">Select Subscriptions</label>
                  <div class="d-flex flex-wrap mt-1" style="gap: 8px;">
                    <div class="custom-checkbox custom-control dashboard-checkbox"
                      v-for="(platform, index) in user.influencerPlatforms" :key="index">
                      <input type="checkbox" class="custom-control-input" true-value="Active"
                        false-value="Inactive"
                        v-model="user.influencerPlatforms[index].status" :id="`platform_${index}`">
                      <label :for="`platform_${index}`" class="custom-control-label">{{
                        platform.platform }}</label>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-md-6 mb-3">
                  <label class="settings-label">Price (Monthly) <span class="danger">*</span></label>
                  <input type="number" min="0" class="form-control settings-input"
                    :placeholder="`Monthly price(currently $${getUser().monthlyPrice})`"
                    v-model.trim="user.monthlyPrice" readonly
                    onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                  <span class="error invalid-feedback" v-if="isRequired('monthlyPrice')">This is required field</span>
                </div>

                <div class="col-12 col-md-6 mb-3">
                  <label class="settings-label">Custom Requests Min Price <span class="danger">*</span></label>
                  <input type="number" class="form-control settings-input" min="0"
                    v-model.trim="user.customRequestMinPrice" @input="validateMinPrice"
                    onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                  <span class="error invalid-feedback"
                    v-if="isRequired('customRequestMinPrice') || isInvalidMinPrice">
                    This is a required field and must be greater than 25
                  </span>
                </div>
              </div>
            </div>

            <!-- SECTION 4: Links -->
            <div class="settings-section mb-4">
              <h6 class="settings-section-title">Links</h6>
              <div class="px-3 py-3">
                <div class="mb-3" v-for="(influencerLink, index) in user.influencerLinks" :key="index">
                  <span v-if="isSubmit && !$v.user.influencerLinks.$each[index].platformName.required"
                    class="error invalid-feedback">This is required field</span>
                  <div class="input-group flex-nowrap p-0">
                    <input type="text" name="link_title" class="form-control settings-input m-0"
                      placeholder="Enter a Title"
                      v-model="user.influencerLinks[index].platformName" style="border-right: none !important; border-top-right-radius: 0 !important; border-bottom-right-radius: 0 !important;">
                    <div class="input-group-prepend input-group-text p-3" style="border-top-left-radius: 0 !important; border-bottom-left-radius: 0 !important;">
                      <span
                        class="bedge link-add-bedge cursor-pointer text-uppercase mx-0 font-family-poppins"
                        @click="addOrEditLink(index)" v-if="!influencerLink.id">Add url</span>
                      <span
                        class="bedge link-edit-bedge cursor-pointer text-uppercase mx-0 font-family-poppins"
                        v-if="influencerLink.id" @click="addOrEditLink(index)">edit</span>
                    </div>
                  </div>
                  <span v-if="isSubmit && !$v.user.influencerLinks.$each[index].url.required"
                    class="error invalid-feedback">This is required field</span>
                  <div class="input-group flex-nowrap mt-2"
                    v-if="showURLs[index].show || (influencerLink.platformName && !influencerLink.id)">
                    <input type="text" name="link_title" class="form-control settings-input p-2 px-3"
                      placeholder="Enter URL"
                      v-model="user.influencerLinks[index].url">
                  </div>

                  <div class="text-center py-2"
                    v-if="influencerLink.platformName || influencerLink.url">
                    <span class="text-danger text-uppercase mx-0 cursor-pointer font-family-poppins"
                      @click="deleteLink(index)">delete</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Footer Actions -->
            <div class="text-center px-2 mb-5">
              <button type="button" class="cp-btn-primary d-inline-flex align-items-center"
                @click="save()">
                <i class="fa fa-check me-2 font-size-12"></i> Save
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
    <model-wall ref="wall" @imageChanged="(isAvatar) => {
      if (!isAvatar) {
        loadWallImages();
      } else {
        loadAvatarImg();
      }
    }" />
  </section>
</template>
<script>

import { mapActions, mapGetters } from "vuex";

import { httpMixin } from "@/mixin/http-mixin";
import { clone, isStringWithOnlySpaces } from "@/common/Utils";
import HeaderMenu from "@/components/module/influencer/shared/HeaderMenu";
import InfluencerMenu from "@/components/module/influencer/shared/InfluencerMenu";
import InfluencerHeader from "@/components/module/influencer/shared/InfluencerHeader";
import { email, required, sameAs, requiredIf } from "vuelidate/lib/validators";
import { constructCustomerURL } from "@/common/baseURL-service";
import GlobalMessage from "@/components/module/shared/GlobalMessage";
import { newSubscriptionMixin } from "@/mixin/new-subscription-mixin";
import LogoutButton from "@/components/module/shared/LogoutButton";
import { SERVICE_CONTENT, SERVICE_IDENTIY } from "@/properties/micro-service";
import ModelWall from "@/components/module/influencer/ModelWall";
import { PLATFORM_STELLA } from "@/properties/close-friend";
import titleMixin from "../../../mixin/title-mixin";
import PwaActionBar from "@/components/module/influencer/shared/PwaActionBar";
import LoadingModal from "@/components/module/shared/LoadingModal";

export default {
  name: 'SettingsMobile',
  title: 'Creator settings',
  mixins: [httpMixin, newSubscriptionMixin, titleMixin],
  components: {
    HeaderMenu, InfluencerMenu, InfluencerHeader,
    GlobalMessage, LogoutButton, ModelWall, PwaActionBar, LoadingModal
  },
  data() {
    return {
      user: {},
      pwd: '',
      repeatPassword: '',
      showURLs: [],
      showSlideBar: false,
      profileImgVer: 0,
      wall1ImgVer: 0,
      wall2ImgVer: 0,
      isSubmit: false,
      isAvatarMissing: false,
      imageURL: '',
      wallImgURLs: [],
      PLATFORM_STELLA,
    }
  },
  validations() {
    return {
      user: {
        name: { required },
        email: { required, email },
        /*   password: {required},*/
        monthlyPrice: { required },
        customRequestMinPrice: { required },
        isInvalidMinPrice: false,
        influencerLinks: {
          required,
          $each: {
            platformName: {
              required: requiredIf((link) => {
                return !!link.url;
              })
            },
            url: {
              required: requiredIf((link) => {
                return !!link.platformName;
              })
            },
          }
        }
      },
      repeatPassword: {
        required: requiredIf(() => {
          return !!this.pwd;
        }),
        sameAs: sameAs(() => {
          return this.pwd;
        })
      },
      pwd: {
        required: requiredIf(() => {
          return !!this.repeatPassword;
        }),
      },
    }
  },
  created() {
    this.user = clone(this.getUser());
    this.user.password = '';
    this.checkLinks();
    this.checkNewSubscription(this.user.id);
    this.loadAvatarImg();
    this.loadWallImages();
  },
  computed: {
    copyLabel() {
      return this.copied ? 'Copied' : 'Copy';
    },
    wall1ImgURL() {
      if (this.wallImgURLs.length === 0) {
        return '';
      } else {
        return this.wallImgURLs[0][0];
      }
    },
    wall1ImgType() {
      if (this.wallImgURLs.length === 0) {
        return '';
      } else {
        return this.wallImgURLs[0][1];
      }
    },
    wall2ImgURL() {
      if (this.wallImgURLs.length === 0 || this.wallImgURLs.length === 1) {
        return '';
      } else {
        return this.wallImgURLs[1][0];
      }
    },
    wall2ImgType() {
      if (this.wallImgURLs.length === 0 || this.wallImgURLs.length === 1) {
        return '';
      } else {
        return this.wallImgURLs[1][1];
      }
    },
    profileImgURL() {
      if (this.imageURL.length !== 0) {
        return this.imageURL[0];
      }
      return '';
    },
    imgURL() {
      if (this.imageURL.length !== 0) {
        return this.imageURL[0];
      }
      return '';
    },
    imgType() {
      if (this.imageURL.length !== 0) {
        return this.imageURL[1];
      }
      return '';
    },
  },
  methods: {
    ...mapGetters(['getUser']),
    ...mapActions(['setUser', 'setMessage']),
    loadWallImages() {
      this.wallImgURLs.splice(0);
      let url = `${SERVICE_CONTENT}/api/v1/public/influencers/${this.user.id}/wall`;
      this.getUnSecureData(url, (wallImgURLs) => {
        this.wall1ImgVer = Math.random();
        this.wall2ImgVer = Math.random();
        let wall1 = wallImgURLs.find(e => e[0].includes('wall1.'));
        let wall2 = wallImgURLs.find(e => e[0].includes('wall2.'));
        if (wall1) {
          this.wallImgURLs.push(wall1);
        }
        if (wall2) {
          this.wallImgURLs.push(wall2);
        }
      });
    },
    checkLinks() {
      this.user.influencerLinks = this.user.influencerLinks.filter(link => link.platformName !== null && link.platformName.trim() !== '');

      let len = this.user.influencerLinks.length;
      if (len > 3) {
        this.user.influencerLinks.splice(3, len - 3);
      }
      for (let i = 0; i < (3 - len); i++) {
        this.user.influencerLinks.push({ id: null, platformName: '', url: '' });
      }
      this.showURLs.push(...[{ show: false }, { show: false }, { show: false }]);
    },
    constructCustomerURL,
    loadAvatarImg() {
      let url = `${SERVICE_CONTENT}/api/v1/influencers/${this.user.id}/crop-avatar`;
      this.getUnSecureData(url, (imageURL) => {
        if (imageURL.length !== 0) {
          this.profileImgVer = Math.random();
          this.imageURL = imageURL;
          this.imageURL[0] = this.imageURL[0] + '?ver=' + this.profileImgVer++;
          this.isAvatarMissing = false;
        } else {
          this.isAvatarMissing = true;
        }
      });
    },
    handleFileUpload() {

      let url = `${SERVICE_CONTENT}/api/v1/influencers/${this.user.id}/avatar`;
      let formData = new FormData();
      //Add the form data we need to submit
      formData.append('file', this.$refs.file.files[0]);

      this.uploadData(url, formData, (data) => {
        this.loadAvatarImg();
      });
    },
    isRequired(attrib) {
      return this.isSubmit && !this.$v.user[attrib].required;
    },
    validateMinPrice() {
      this.isInvalidMinPrice = this.user.customRequestMinPrice < 25;
    },
    isValidEmail() {
      return this.isSubmit && !this.$v.user.email.email;
    },

    save() {
      this.isSubmit = true;
      this.$v.$touch();
      if (this.$v.$invalid || this.isInvalidMinPrice) {
        console.log('failed', this.$v);
        return;
      }

      this.user.password = this.pwd;
      this.user.annuallyPrice = this.user.monthlyPrice * 10;
      this.$set(this.user, 'email', this.user.email);
      this.$set(this.user, 'influencerPlatforms', this.user.influencerPlatforms);
      this.$set(this.user, 'influencerLinks', this.user.influencerLinks);
      this.removeEmptyLinks();

      this.patchData(`${SERVICE_IDENTIY}/api/v1/influencers/${this.user.id}`, this.user, (data) => {
        this.user = data;
        this.pwd = this.repeatPassword = '';
        this.isSubmit = false;
        this.setUser(data);
        this.checkLinks();
        this.setMessage('SAVED.SUCCESSFULLY');
      });
    },
    removeEmptyLinks() {
      // let len = this.user.influencerLinks.length;
      let filtered = this.user.influencerLinks.filter((influencerLink) => {
        return (influencerLink.platformName && influencerLink.url)
      });
      /* for (let i = 0; i < len; i++) {
         if (!this.user.influencerLinks[i].platformName && !this.user.influencerLinks[i].url) {
           this.user.influencerLinks.splice(i, 1);
         }
       }*/
      this.user.influencerLinks.splice(0);
      this.user.influencerLinks.push(...filtered);
    },
    slideBar() {
      this.showSlideBar = !this.showSlideBar;
    },
    imageLoadError(event) {
      this.isAvatarMissing = true;
    },
    addOrEditLink(index) {
      //this.links[index].addURL = true;
      this.showURLs[index].show = true;
    },
    deleteLink(index) {
      this.user.influencerLinks.splice(index, 1);
      this.user.influencerLinks.push({ id: null, platformName: '', url: '' });
    }
  }
}
</script>

<style scoped>
/* ===== PAGE BACKGROUND ===== */


/* ===== SECTION CARDS ===== */
.settings-section {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  overflow: hidden;
  transition: border-color 0.3s ease;
}
.settings-section:hover {
  border-color: rgba(255, 89, 212, 0.3);
}

.settings-section-title {
  color: rgba(255, 255, 255, 0.5);
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  padding: 12px 20px;
  margin: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

/* ===== FORM LABELS ===== */
.settings-label {
  color: rgba(255, 255, 255, 0.6) !important;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 6px;
  display: block;
}

/* ===== ALL FORM INPUTS — HIGH SPECIFICITY TO BEAT BOOTSTRAP ===== */
.settings-page .settings-input,
.settings-page .settings-input.form-control,
.settings-page input.settings-input,
.settings-page input.form-control.settings-input {
  background-color: rgba(255, 255, 255, 0.06) !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
  color: #ffffff !important;
  border-radius: 10px !important;
  padding: 10px 14px !important;
  font-size: 14px;
  transition: all 0.2s ease;
  -webkit-text-fill-color: #ffffff !important;
}
.settings-page .settings-input:focus,
.settings-page .settings-input.form-control:focus {
  border-color: #ff59d4 !important;
  box-shadow: 0 0 0 3px rgba(255, 89, 212, 0.15) !important;
  background-color: rgba(255, 255, 255, 0.08) !important;
  outline: none !important;
}
.settings-page .settings-input::placeholder {
  color: rgba(255, 255, 255, 0.25) !important;
  -webkit-text-fill-color: rgba(255, 255, 255, 0.25) !important;
}
.settings-page .settings-input[readonly] {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Fix browser autofill styling overriding dark mode */
.settings-page .settings-input:-webkit-autofill,
.settings-page .settings-input:-webkit-autofill:hover,
.settings-page .settings-input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 1000px #2a2a2a inset !important;
  box-shadow: 0 0 0 1000px #2a2a2a inset !important;
  -webkit-text-fill-color: #ffffff !important;
  color: #ffffff !important;
  caret-color: #ffffff !important;
  transition: background-color 50000s ease-in-out 0s !important;
}

.settings-page .settings-input:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0 1000px #2a2a2a inset, 0 0 14px rgba(229, 59, 185, 0.35) !important;
  box-shadow: 0 0 0 1000px #2a2a2a inset, 0 0 14px rgba(229, 59, 185, 0.35) !important;
  border-color: #E53BB9 !important;
  -webkit-text-fill-color: #ffffff !important;
  color: #ffffff !important;
  caret-color: #ffffff !important;
  outline: none !important;
  transition: background-color 50000s ease-in-out 0s !important;
}

/* ===== INPUT GROUP (Links section) ===== */
.settings-page .input-group-text {
  background-color: rgba(255, 255, 255, 0.04) !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}
.settings-page .input-group-text .bedge {
  color: #55EFC4 !important;
  font-size: 12px;
}

/* ===== CHECKBOXES ===== */
.settings-page .custom-control-label {
  color: rgba(255, 255, 255, 0.85) !important;
}
.settings-page .custom-control-label::before {
  background-color: rgba(255, 255, 255, 0.08) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
}
.settings-page .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #ff59d4 !important;
  border-color: #ff59d4 !important;
}

/* ===== PROFILE IMAGES ===== */
.settings-page .img-wrapper-main {
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  cursor: pointer;
}
.settings-page .img-wrapper-main:hover {
  border-color: rgba(255, 89, 212, 0.5);
  box-shadow: 0 0 12px rgba(255, 89, 212, 0.15);
}

/* ===== TRANSPARENT BACKGROUNDS ===== */
.settings-page .container-fluid,
.settings-page .row,
.settings-page .col-12,
.settings-page .col-md-6 {
  background-color: transparent !important;
  background-image: none !important;
}
</style>
